import { gsap, ScrollTrigger, ScrollToPlugin } from 'gsap/all';
import { ScrollSmoother } from '../vendor/gsap/ScrollSmoother';
import smoov from '../util/smooth-scroll';
import btnAnimate from '../text-animations/btn';
import './detail/work-detail';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

smoov();

// Intro text custom animation
const line = $('.turbo-line');
const workPanel = $('.featured-work-panel');

if (line.length > 0) {
    gsap.set(line, {
        scaleX: 0,
    });

    // Featured work intro row
    gsap.to('.js-turbo-line-wrap .turbo-line', {
        scaleX: 1,
        ease: 'linear',
        scrollTrigger: {
            trigger: '.intro-row',
            start: 'top 90%',
            end: 'bottom 60%',
            scrub: true,
        },
    });
}
if ($('.cc-featured-photos-item').length > 0) {
    // Feat work photo / copy pinning
    const copyItem = $('.js-copy-group.js-pin-200px');
    const photoToScroll = $('.cc-featured-photos-item:not(:last-child)');
    const itemsToPinTotal = photoToScroll.length;
    const scrollEndPercentage = itemsToPinTotal * 100;
    const endPercent = `+=${scrollEndPercentage}%`;

    const mm = gsap.matchMedia();

    // Desktop only
    mm.add('(min-width: 992px)', () => {
        // Pin the copy for a little bit to associate it with the photo
        gsap.utils.toArray(copyItem).forEach((elem) => {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem,
                    start: 'top top',
                    end: '+=21.6%',
                    pin: true,
                    scrub: true,
                    pinSpacing: true,
                    anticipatePin: true,
                    id: 'copy_item',
                },
            });
        });

        // Set all the photos to have sequential descending zIndex
        gsap.set('.cc-featured-photos-item', { zIndex: (i, target, targets) => targets.length - i });

        gsap.to(photoToScroll, {
            yPercent: -100,
            ease: 'none',
            stagger: 1,
            scrollTrigger: {
                trigger: '.cc-featured-photos',
                start: 'top top',
                end: endPercent,
                scrub: true,
                pin: true,
                id: 'photo_to_scroll',
            },
        });

        // Color the panels
        gsap.utils.toArray('.cc-featured-item').forEach((elem) => {
            const color = elem.getAttribute('data-project-bg');

            ScrollTrigger.create({
                trigger: elem,
                start: 'top 50%',
                end: 'bottom 50%',
                onEnter: () => gsap.to(workPanel, { backgroundColor: color }),
                onLeave: () => gsap.to(workPanel, { backgroundColor: 'white' }),
                onLeaveBack: () => gsap.to(workPanel, { backgroundColor: 'white' }),
                onEnterBack: () => gsap.to(workPanel, { backgroundColor: color }),
                id: 'data_bg',
            });
        });
    }); // desktop
}

if ($('.fixed-masthead').length > 0) {
    ScrollTrigger.create({
        trigger: '.fixed-masthead',
        start: 'top bottom',
        end: 'bottom top',
        EnterBack: () => gsap.to('.masthead-background-image', { visibility: 'visible' }),
        onLeave: () => gsap.to('.masthead-background-image', { visibility: 'hidden' }),
        onLeaveBack: () => gsap.to('.masthead-background-image', { visibility: 'visible' }),
        onEnterBack: () => gsap.to('.masthead-background-image', { visibility: 'visible' }),
    });
}

// For after dom loaded
function checkForBtn() {
    $('.js-btn-split').each((e, index) => {
        btnAnimate(index);
    });
}

if ($('body').hasClass('success-stories-index')) {
    document.body.addEventListener('htmx:afterSettle', (evt) => {
        // evt.preventDefault();
        ScrollTrigger.refresh();
        checkForBtn();
    });
}

document.body.addEventListener('htmx:afterSwap', () => {
    const moreWorkButton = document.getElementById('js-more-work');
    if (!moreWorkButton) {
        const workContainer = document.getElementById('work-card-grid');

        if (workContainer) {
            workContainer.classList.remove('load-more-padding-bottom');
        }
    }
});
